export default __webpack_public_path__ + "static/vs-statuses-4e286f48a691baf00f405be67e7160ec.png";